import { render, staticRenderFns } from "./SupportWidgetAnonymousDialog.vue?vue&type=template&id=7de869a4&scoped=true&"
import script from "./SupportWidgetAnonymousDialog.vue?vue&type=script&lang=ts&"
export * from "./SupportWidgetAnonymousDialog.vue?vue&type=script&lang=ts&"
import style0 from "./SupportWidgetAnonymousDialog.vue?vue&type=style&index=0&id=7de869a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7de869a4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VContainer,VIcon,VMenu})
